import { useTranslation } from 'react-i18next';
import { Presentation } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
import { PageShell } from '@/shared/components/page';
import { TemplateSlotCard } from '../components/templates/TemplateSlotCard';
import { useProposalTemplates } from '../hooks/useProposalTemplates';
import { errorMessage } from '../lib/errors';
import type { Lang } from '../types';

/** /crm/settings/proposal-templates — directors and full admins register the deck templates (plan ruling 1). */
export function ProposalTemplatesPage() {
  const { t } = useTranslation('crm');
  const { data, isLoading, isError, error } = useProposalTemplates();
  const slot = (language: Lang) => data?.find((tpl) => tpl.offerType === 'monitoring' && tpl.language === language);
  return (
    <PageShell Icon={Presentation} subtitle={t('proposalTemplates.subtitle')}>
      <div className="space-y-4">
        <p className="max-w-3xl text-sm text-muted-foreground">{t('proposalTemplates.intro')}</p>
        {isError ? (
          <Alert variant="destructive"><AlertDescription>{t('proposalTemplates.loadFailed')} {errorMessage(error)}</AlertDescription></Alert>
        ) : isLoading ? (
          <Skeleton className="h-64 w-full" />
        ) : (
          <div className="grid gap-4 lg:grid-cols-2">
            <TemplateSlotCard language="en" template={slot('en')} />
            <TemplateSlotCard language="fr" template={slot('fr')} />
          </div>
        )}
      </div>
    </PageShell>
  );
}
